<template>
  <q-dialog ref="dialog"
            full-width
            persistent>
    <q-card class="edit-page edit-order-page">
      <q-card-section>
        <div class="page-subtitle">
          {{ item.id ? 'Edit' : 'New' }} quote {{item.id ? `#${item.id}` : ''}}
        </div>

        <q-tabs v-model="tab" dense>
          <q-tab label="Info" name="info" icon="fas fa-info">
            <strong class="text-primary">${{ item.price }}</strong>
          </q-tab>
          <q-tab label="Products" name="products" icon="fas fa-tools">
            <q-badge floating color="primary" :label="itemsCount"></q-badge>
          </q-tab>
          <q-tab label="Deal Calculator" name="calculator" icon="fas fa-dollar-sign"/>
          <q-tab label="Email Quote" name="email" icon="fas fa-envelope"/>
        </q-tabs>

        <q-tab-panels v-model="tab" >
          <q-tab-panel name="info">
            <q-form class="page-content"
                    ref="form"
                    autocorrect="off"
                    autocapitalize="off"
                    autocomplete="off"
                    spellcheck="false"
                    @submit="save()">
              <div class="page-content-white">
                <div class="form-group">
                  <date-picker value-type="format"
                               format="DD/MM/YYYY"
                               id="created_at"
                               label="Created date"
                               ref="created_at"
                               v-model="item.created_at"
                  ></date-picker>
                </div>
                <div class="form-group">
                  <user-select :item="item" prop="user_id" label="Select user"></user-select>
                </div>

                <div class="form-group">
                  <q-input v-model="item.price" :rules="requiredRules" label="Total Price" type="number" step="1" filled dense/>
                </div>

                <div class="form-group">
                  <q-input v-model="item.comment" label="User comment" type="textarea" filled dense/>
                </div>

                <div class="form-group">
                  <q-input v-model="item.customer_order_number" label="User order number" filled dense/>
                </div>

                <div class="form-group">
                  <q-input v-model="item.admin_comment" label="Admin comment" type="textarea" filled dense/>
                </div>
              </div>
            </q-form>
          </q-tab-panel>
          <q-tab-panel name="products">
            <quote-items-editor :order="item"></quote-items-editor>
          </q-tab-panel>
          <q-tab-panel name="calculator">
            <quote-calculator :order="item"></quote-calculator>
          </q-tab-panel>
          <q-tab-panel name="email">
            <quote-email :quote="item" />
          </q-tab-panel>
        </q-tab-panels>


      </q-card-section>
      <q-card-actions align="right">
        <q-btn flat
               color="primary"
               label="Close"
               class="q-mr-md"
               @click="hide()"></q-btn>

        <q-btn label="Close"
               color="primary"
               :label="item.id ? 'Update' : 'Create'"
               class="q-mr-md"
               @click="hide()"></q-btn>

      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

  import {copy} from "./boot/axios";
  import UserSelect from "./UserSelect.vue";
  import QuoteItemsEditor from "./OrderItemsEditor.vue";
  import 'vue2-datepicker/index.css';
  import DatePicker from "vue2-datepicker";
  import QuoteEmail from "./QuoteEmail.vue";
  import QuoteCalculator from "./QuoteCalculator.vue";

  export default {
    name: 'EditQuote',
    components: {QuoteCalculator, QuoteEmail, QuoteItemsEditor, UserSelect, DatePicker},
    props: ['quote'],
    data() {
      return {
        tab: 'info',
        item: {
          'id': '',
          "user_id": null,
          "status": 'New Quote',
          "price": 0,
          "comment": '',
          "admin_comment": '',
          "details": {},
          "customer_name": '',
          "customer_phone": '',
          "customer_email": '',
          "customer_order_number": '',
          "deal_calculation": null,
          "quote_approved": 0,
        },
      };
    },
    mounted() {
      setTimeout(() => {
        this.item = copy(this.quote)

        if (this.quote.id){
          this.get()
        } else {
          this.item.description = this.item.description || ''
        }
      })
    },
    methods: {
      get() {
        this.axiosGet(`/${this.routePrefix}/get/` + this.item.id)
            .then((r) => {
              this.item = r.data;
              this.$forceUpdate()
            })
      },
      async save() {
        this.tab = 'info'

        setTimeout(async () => {
          if(!await this.$refs.form.validate()){
            return false
          }

          this.axiosPost(`/${this.routePrefix}/save`, this.item)
              .then((r) => {
                this.get()

                this.$q.notify({
                  message: 'Quote saved!',
                  type: 'positive',
                });
              })
        }, 100)
      },

      // following method is REQUIRED
      // (don't change its name --> "show")
      show () {
        this.$refs.dialog.show()
      },

      // following method is REQUIRED
      // (don't change its name --> "hide")
      hide () {
        this.$refs.dialog.hide()
      },

      onDialogHide () {
        // required to be emitted
        // when QDialog emits "hide" event
        this.$emit('hide')
      },

      onOKClick () {
        // on OK, it is REQUIRED to
        // emit "ok" event (with optional payload)
        // before hiding the QDialog
        this.$emit('ok')
        // or with payload: this.$emit('ok', { ... })

        // then hiding dialog
        this.hide()
      },

      onCancelClick () {
        // we just need to hide dialog
        this.hide()
      }

    },
    computed: {
      itemsCount(){
        try {
          return Object.keys(this.item.details.items).length
        } catch {
          return 0
        }
      },
      routePrefix(){
        return 'admin_quotes'
      },
      statuses(){
        return this.$store.state.quoteStatuses
      },
    }
  };
</script>

<style scoped>

</style>
